import { createAction } from 'redux-act';

export const loadActivity = createAction();
export const activityLoaded = createAction();
export const setCurrentActivity = createAction();
